import { render } from "./Password.svg?vue&type=template&id=7dd6d856"
const script = {}
script.render = render

export default script